import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router";
import AccordianTable from "../general/SubmissionTable";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import ProfileSection from "./profile/ProfileSection";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import * as Sentry from "@sentry/browser";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    moneyInput: {
      width: "80%",
      maxWidth: "200px",
    },
    sideMargin: {
      margin: "10px 0px",
      width: "100%",
    },
    text: {
      fontFamily: "SuperaGothic",
      fontWeight: "bold",
    },
    normalText: {
      fontFamily: "SuperaGothic",
      //marginBottom: '10px',
      fontSize: "16px",
    },
    buttonText: {
      fontFamily: "SuperaGothic",
    },
    root: {
      [theme.breakpoints.down("sm")]: {
        margin: "0px 15px",
      },
      [theme.breakpoints.up("sm")]: {
        margin: "0rem 3rem",
      },
      //minHeight: "70%",
    },
  })
);

export interface Submission {
  createdAt: string;
  updatedAt: string;
  id: number;
  generalApplicationProfile?: GeneralProfile;
  draftCases: Array<DraftCase>;
  cases: Array<Case>;
}

export interface GeneralProfile {
  id: number;
  status: string;
}

export interface Case {
  id: number;
  status: string;
}

export interface DraftCase {
  id: number;
  status: string;
}

export default function EarningsPage() {
  const classes = useStyles();
  const [pendingReviewCases, setPendingReviewCases] = useState<
    Array<Submission>
  >([]);
  const [pendingRevisionCases, setPendingRevisionCases] = useState<
    Array<Submission>
  >([]);
  const [pendingConfirmationCases, setPendingConfirmationCases] = useState<
    Array<Submission>
  >([]);
  const history = useHistory();
  useEffect(() => {
    axios(`api/v1/get_submissions_by_status`, {
      method: "POST",
      withCredentials: true,
      data: {
        status: "pending_review",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        var embededData = data.data;
        if (embededData) {
          var cases = embededData.cases as Array<Submission>;
          if (cases) {
            setPendingReviewCases(cases);
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        } else {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        }
        Sentry.captureException(error);
      });

    axios(`api/v1/get_submissions_by_status`, {
      method: "POST",
      withCredentials: true,
      data: {
        status: "needs_revision",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        var embededData = data.data;
        if (embededData) {
          var cases = embededData.cases as Array<Submission>;
          if (cases) {
            setPendingRevisionCases(cases);
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        } else {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        }
        Sentry.captureException(error);
      });

    axios(`api/v1/get_submissions_by_status`, {
      method: "POST",
      withCredentials: true,
      data: {
        status: "pending_confirmation",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        var embededData = data.data;
        if (embededData) {
          var cases = embededData.cases as Array<Submission>;
          if (cases) {
            setPendingConfirmationCases(cases);
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        } else {
          // TODO: add error logger
          history.replace({
            pathname: "/503",
            state: { from: history.location },
          });
        }
        Sentry.captureException(error);
      });
  }, [history]);

  return (
    <div className={`${classes.root} page-container`}>
      <Helmet>
        <title>Submitted applications - CollegeSharing</title>
      </Helmet>
      {pendingReviewCases && (
        <ProfileSection title="Key Statistics">
          <Grid container spacing={3}>
            <Grid item xs={6} sm={4} md={4} lg={3} xl={3}>
              <Typography variant="h3">{pendingReviewCases.length}</Typography>
              <Typography variant="h6">Pending Review</Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4} lg={3} xl={3}>
              <Typography variant="h3">
                {pendingRevisionCases.length}
              </Typography>
              <Typography variant="h6">Pending Revision</Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4} lg={3} xl={3}>
              <Typography variant="h3">
                {pendingConfirmationCases.length}
              </Typography>
              <Typography variant="h6">Pending Confirmation</Typography>
            </Grid>
          </Grid>
        </ProfileSection>
      )}
      {pendingReviewCases && (
        <ProfileSection title="Pending Review">
          <AccordianTable submissions={pendingReviewCases} />
        </ProfileSection>
      )}
      {pendingRevisionCases && (
        <ProfileSection title="Pending Revision">
          <AccordianTable submissions={pendingRevisionCases} />
        </ProfileSection>
      )}
      {pendingConfirmationCases && (
        <ProfileSection title="Pending Confirmation">
          <AccordianTable submissions={pendingConfirmationCases} />
        </ProfileSection>
      )}
    </div>
  );
}
